import React from "react";

import { Card } from "components";

export const IllustrationCard = ({ children, onClick = () => {}, className = "" }) => (
  <Card onClick={onClick} className={`illustration-card ${className}`} mixpanelText="illustration-card">
    {children}
  </Card>
);

export default IllustrationCard;
